<template>
    <div class="page">
        <Nav></Nav>
        <div class="banner" id="banner">
            <div class="vantaRef" ref="vantaRef"></div>
            <div class="companyInfo needVisible" ref="companyInfo">
                {{ $t('nav.companyName') }}
                <span class="companySlogan">WE<span></span>DO<span></span>IT</span>
            </div>
            <div class="more">
                <div class="circle1"></div>
                <div class="circle2">
                    <div class="moreText">{{ $t('banner.more') }}</div>
                    <div class="arrow_view_sj"></div>
                </div>
            </div>
        </div>
        <Advantage class="needVisible"></Advantage>
        <Scene class="needVisible"></Scene>
        <Partner class="needVisible"></Partner>
        <ContactUs></ContactUs>
        <div class="totop" @click.stop="toTop()" v-if="showGoTop">
            <img src="https://4d-ai.chat/img/totop.png">
        </div>
    </div>
</template>

<script>
import * as THREE from 'three'
import WAVES from 'vanta/dist/vanta.waves.min'
import Advantage from '@/components/Advantage.vue';
import Scene from '@/components/Scene.vue';
import ContactUs from '@/components/ContactUs.vue';
import Partner from '@/components/Partner.vue';
import Nav from '@/components/Nav.vue';
export default {
    name: 'Home',
    data() {
        return {
            showGoTop: false,
            vantaEffect: null,
        }
    },
    components: {
        Advantage,
        Scene,
        ContactUs,
        Nav,
        Partner
    },
    mounted() {
        window.addEventListener("scroll", this.handleScroll, true);
        this.vantaEffect = WAVES({
            el: this.$refs.vantaRef,
            THREE: THREE,
            mouseControls: true,
            touchControls: true,
            gyroControls: false,
            minHeight: 200.00,
            minWidth: 200.00,
            scale: 1.00,
            scaleMobile: 1.00,
            color: '#223474',
        })
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                } else {
                }
            });
        }, {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        });
        const boxes = document.querySelectorAll('.needVisible');
        boxes.forEach(box => {
            observer.observe(box);
        });
    },
    beforeDestroy() {
        if (this.vantaEffect) {
            this.vantaEffect.destroy()
        }
    },
    methods: {
        handleScroll() {
            let scrolltop = document.documentElement.scrollTop;
            if (scrolltop > window.innerHeight) {
                this.showGoTop = true
            } else {
                this.showGoTop = false
            }
        },
        toTop() {
            document.documentElement.scrollTop = 0;
        },
    }
}
</script>
<style scoped>
@media (max-width: 768px) {
    .page {
        word-break: break-all !important;
    }

    .totop {
        width: 48px !important;
        bottom: 100px !important;
        height: 56px !important;
    }

    .banner {
        height: 30vh !important;
        padding-top: 40px !important;
        box-sizing: border-box !important;
    }

    .vantaRef {
        height: 30vh !important;
    }

    .companyInfo {
        font-size: 40px !important;
    }

    .companySlogan {
        font-size: 24px !important;
    }

    .more {
        display: none !important;
    }
}
</style>
<style scoped lang="less">
.page {
    width: 100%;
    overflow-x: hidden;
    word-break: break-all;

    .totop:hover {
        background: #2743af;
    }

    .totop {
        width: 48px;
        height: 56px;
        background-color: #243c8a;
        position: fixed;
        z-index: 20;
        right: 30px;
        bottom: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s;
        cursor: pointer;

        img {
            width: 45%;
        }
    }

    .banner {
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        position: relative;
        gap: 24px;

        .vantaRef {
            width: 100%;
            height: 100vh;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
        }

        .companyInfo {
            font-size: 72px;
            color: #ffffff;
            font-weight: 600;


            .companySlogan {
                font-size: 24px;
                color: #c3dcfe;
                display: flex;
                align-items: center;
                justify-content: center;

                span {
                    width: 20px;
                }
            }
        }

        .more {
            position: absolute;
            bottom: 50px;
            width: 200px;
            height: 200px;

            @keyframes scaleDraw1 {
                0% {
                    transform: scale(1)
                }

                25% {
                    transform: scale(.9)
                }

                50% {
                    transform: scale(.8)
                }

                75% {
                    transform: scale(.9)
                }

                to {
                    transform: scale(1)
                }
            }

            @keyframes scaleDraw2 {
                0% {
                    transform: scale(.8)
                }

                25% {
                    transform: scale(.9)
                }

                50% {
                    transform: scale(1)
                }

                75% {
                    transform: scale(.9)
                }

                to {
                    transform: scale(.8)
                }
            }

            .circle2 {
                position: absolute;
                top: 20px;
                left: 20px;
                border: 1px solid #fff;
                width: 160px;
                height: 160px;
                border-radius: 50%;
                animation-name: scaleDraw2;
                animation-timing-function: ease-in-out;
                animation-iteration-count: infinite;
                animation-duration: 6s;
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: center;
                color: #fff;


                .arrow_view_sj {
                    width: 30px;
                    height: 30px;
                    border-top: 2px solid #fff;
                    border-left: 2px solid #fff;
                    transform: rotate(-135deg);
                }
            }

            .circle1 {
                position: absolute;
                border: 1px solid #fff;
                width: 200px;
                height: 200px;
                border-radius: 50%;
                animation-name: scaleDraw1;
                animation-timing-function: ease-in-out;
                animation-iteration-count: infinite;
                animation-duration: 6s;
                animation-delay: 1s
            }
        }
    }

    .needVisible {
        opacity: 0;
        transform: translateY(20px);
        transition: all 1s ease-out;
    }

    .visible {
        opacity: 1;
        transform: translateY(0);
    }

    .nav {
        box-shadow: 0 2px 10px #0000001a;
        height: 64px;
        padding: 0 212px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        background-color: #28408e;
        position: fixed;
        top: 0;
        width: 100%;
        color: #fff;
        z-index: 3;

        img {
            width: 58px;
        }

        .link:hover {
            color: #fff;
        }

        .link {
            font-size: 16px;
            margin-left: 32px;
            cursor: pointer;
            color: #FFFFFFB3;
            text-decoration: none;
        }

        .company {
            font-size: 24px;
            font-weight: 600;
        }
    }
}
</style>
